/* Design tokens and helpers shared across V2 pages */

export const PRIORITIES = {
  urgent:   { label: 'Acil',    hex: '#dc2626', key: 'urgent' },
  high:     { label: 'Yüksek',  hex: '#ea580c', key: 'high' },
  medium:   { label: 'Orta',    hex: '#eab308', key: 'medium' },
  low:      { label: 'Düşük',   hex: '#16a34a', key: 'low' },
};

export const STATUS = {
  beklemede:  { label: 'Beklemede',  key: 'beklemede',  text: 'var(--text-muted)', dot: '#8a909a', weak: 'var(--surface-2)' },
  pending:    { label: 'Beklemede',  key: 'pending',    text: 'var(--text-muted)', dot: '#8a909a', weak: 'var(--surface-2)' },
  todo:       { label: 'Beklemede',  key: 'todo',       text: 'var(--text-muted)', dot: '#8a909a', weak: 'var(--surface-2)' },
  'işlemde':  { label: 'İşlemde',    key: 'işlemde',    text: 'var(--accent)',     dot: '#1E5FA8', weak: 'var(--accent-weak)' },
  in_progress:{ label: 'İşlemde',    key: 'in_progress',text: 'var(--accent)',     dot: '#1E5FA8', weak: 'var(--accent-weak)' },
  incelemede: { label: 'İncelemede', key: 'incelemede', text: 'var(--review)',     dot: '#6c4ca9', weak: 'var(--review-weak)' },
  review:     { label: 'İncelemede', key: 'review',     text: 'var(--review)',     dot: '#6c4ca9', weak: 'var(--review-weak)' },
  tamamlandi: { label: 'Tamamlandı', key: 'tamamlandi', text: 'var(--good)',       dot: '#1a7f4f', weak: 'var(--good-weak)' },
  completed:  { label: 'Tamamlandı', key: 'completed',  text: 'var(--good)',       dot: '#1a7f4f', weak: 'var(--good-weak)' },
  done:       { label: 'Tamamlandı', key: 'done',       text: 'var(--good)',       dot: '#1a7f4f', weak: 'var(--good-weak)' },
};

/* deterministic color generation for avatar fallback */
const PALETTE = ['#1E5FA8', '#7c3aed', '#0ea5e9', '#16a34a', '#db2777', '#ea580c', '#0891b2', '#b45309', '#4f46e5', '#be185d'];
export function colorFor(seed = '') {
  let h = 0;
  for (let i = 0; i < seed.length; i++) h = (h * 31 + seed.charCodeAt(i)) >>> 0;
  return PALETTE[h % PALETTE.length];
}

export function initialsFor(name = '') {
  const parts = String(name).trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return '·';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

export function userDisplay(u) {
  if (!u) return { name: '—', initials: '·', color: '#8a909a', role: '', email: '' };
  const name = u.name || u.full_name || u.email || '—';
  return {
    id: u.id || u._id || u.user_id,
    name,
    email: u.email || '',
    role: u.role || '',
    initials: u.initials || initialsFor(name),
    color: u.color || colorFor(u.id || u._id || name),
  };
}

export function statusMeta(key) {
  if (!key) return STATUS.beklemede;
  const normalized = String(key).toLowerCase();
  return STATUS[key] || STATUS[normalized] || STATUS.beklemede;
}

export function priorityMeta(key) {
  if (!key) return PRIORITIES.medium;
  return PRIORITIES[key] || PRIORITIES[String(key).toLowerCase()] || PRIORITIES.medium;
}
